import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

import dmu from './dmu'
import ci from './criticalIncidents'
import miuRecommendations from './miuRecommendations'
import oigRecommendations from './oigRecommendations'
import scmu from './scmu'
export default new Vuex.Store({
  state: {
    baseUrl: process.env.VUE_APP_BASEURL,
    data: {},
    recommendations: []
  },
  mutations: {
    DATA: (state, data) => {
      state.data = data
    },
    RECOMMENDATION_DATA: (state, data) => {
      state.recommendations = data
    }
  },
  getters: {
    oigRecommendations: (state) => {
      return state.recommendations.filter(function(r) {
        return r.service !== 'Medical Inspections'
      })
    },
    dmuData: (state) => {
      return state.data.dmu
    },
    ciData: (state) => {
      return state.data.criticalIncidents
    }
  },
  actions: {
    async loadRecommendations({
      commit,
      state
    }) {
      return await axios.get(state.baseUrl + 'api/recommendations/export').then((res) => {
        commit('RECOMMENDATION_DATA', res.data.recommendations)
      })

    }
  },
  modules: {
    dmu,
    ci,
    miuRecommendations,
    oigRecommendations,
    scmu
  }
})
